module.exports = __webpack_public_path__ + "img/bromiliad2.0129a794.jpg";